let paralaxInstances

let windowHeight
let currentScroll

let mediaQuery = '(min-width: 64em)'

export function Paralax() {
    const Els = document.querySelectorAll('[data-paralax]')
    if (!Els.length) {
        return
    }

    windowHeight = window.innerHeight

    paralaxInstances = Array.from(Els).map((paralaxContainer) => {
        const height = paralaxContainer.offsetHeight
        const top = paralaxContainer.offsetTop

        let items = Array.from(paralaxContainer.querySelectorAll('[data-paralax-item]')).map(
            (paralaxItem) => {
                const range = windowHeight * 2 - (windowHeight - height)

                return {
                    el: paralaxItem,
                    range
                }
            }
        )

        return {
            paralaxContainer,
            top,
            height,
            items,
            progress: 0,
            animationID: null,
            updateItems: updateFixed
        }
    })

    updateOnScroll()

    window.addEventListener('resize', updateOnResize)
    window.addEventListener('scroll', updateOnScroll)
}

function updateOnScroll() {
    if (!window.matchMedia(mediaQuery).matches) {
        return
    }

    currentScroll = window.scrollY

    paralaxInstances.forEach((el) => {
        el.updateItems()
    })
}

function updateOnResize() {
    windowHeight = window.innerHeight

    paralaxInstances.forEach((paralaxInstance) => {
        paralaxInstance.height = paralaxInstance.paralaxContainer.offsetHeight
        paralaxInstance.top = paralaxInstance.paralaxContainer.offsetTop

        paralaxInstance.items.forEach((item) => {
            item.range = windowHeight * 2 - (windowHeight - paralaxInstance.height)
        })
    })

    updateOnScroll()
}

function updateFixed() {
    if (this.animationID) {
        return
    }

    this.animationID = requestAnimationFrame(() => {
        this.progress =
            (currentScroll + windowHeight - this.top) / ((windowHeight + this.height) / 100)
        this.progress = Math.min(Math.max(this.progress, -1), 101)

        if (this.progress < 0 || this.progress > 100) {
            this.animationID = null
            return
        }
        const containerHeightDiff = windowHeight - this.height
        const range = windowHeight * 2 - containerHeightDiff

        this.items.forEach((item) => {
            const transform = (this.progress / 100) * range - range / 2 - containerHeightDiff / 2

            item.el.style.transform = `translate3d(0, ${transform}px, 0)`
        })
        this.animationID = null
    })
}
